import { Button, Flex, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { Id } from '@feature/utils';

import { getArticleBestQ } from '../model/ArticleQuery';

interface ArticleBestQProps {
  articleId: Id;
}

export function ArticleBestQ({ articleId }: ArticleBestQProps) {
  const { data, isLoading, refetch } = useQuery(getArticleBestQ(articleId));
  const { t } = useTranslation();

  return (
    <Flex
      gap="sm"
      align="center"
    >
      <Text
        c="dimmed"
        fs="italic"
        w="70%"
      >
        {t('journals.bestQ.title')}
      </Text>
      {!!data && <Text>{t('journals.bestQ.value', { quater: data.quater, type: data.type })}</Text>}
      {!data && (
        <Button
          size="xs"
          loading={isLoading}
          onClick={() => refetch()}
        >
          {t('journals.bestQ.load')}
        </Button>
      )}
    </Flex>
  );
}
